// This is here because CSP violations are very hard to debug unless you dump the whole event
// object to the console.
document.addEventListener("securitypolicyviolation", (e) => {
  console.error(e)
})

import "es6-shim"

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    // tslint:disable-next-line
    targetLength = targetLength >> 0 // truncate if number or convert non-number to 0;
    padString = String(typeof padString !== "undefined" ? padString : " ")
    if (this.length > targetLength) {
      return String(this)
    } else {
      targetLength = targetLength - this.length
      if (targetLength > padString.length) {
        // append to original to ensure we are longer than needed
        padString += padString.repeat(targetLength / padString.length)
      }
      return padString.slice(0, targetLength) + String(this)
    }
  }
}

import * as React from "react"
import * as ReactDOM from "react-dom"
import {App} from "./App"
// import registerServiceWorker from "./registerServiceWorker"
import "./index.css"
import "./semantic-dist/semantic.css"
import "./semantic-ui-overrides.css"
import "rc-time-picker/assets/index.css"
import "./time-picker-override.css"
import {ErrorBoundary} from "./ErrorBoundary"
import {Unsupported, unsupportedBrowser} from "./components/Unsupported"

ReactDOM.render(
  unsupportedBrowser() ? (
    <Unsupported />
  ) : (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  ),
  document.getElementById("root"),
)
// registerServiceWorker()

// I have disabled the service worker feature because the following call is made in the browser
// after doing an auth0 login and this is something we *must not cache*.  Of course we could eject
// from create-react-app and customize the options of sw-precache-webpack-plugin but KISS for now.

// Request URL:https://cusoon.gtod.net/backend/login-callback?code=V_Xad4eqyIAXyQGf&state=dc2en8qv1pp2b8caunnis40b56
// Request Method:GET
// Status Code:200 OK (from ServiceWorker)
// Remote Address:35.189.15.197:443
// Referrer Policy:no-referrer-when-downgrade



// WEBPACK FOOTER //
// ./src/index.tsx